import { useQuery } from '@tanstack/react-query';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import useApi from '../../api/backendApiContext';
import { ReactQueryConstants } from '../../commons/constants';
import { QueryStatus } from '../../commons/components/QueryStatus';

export const useFetchedYouTubeAccount = () => {
  const { socialPostingApi } = useApi();
  const cacheManager = useQueryCacheManager();
  const queryKey = cacheManager.getYouTubeAccountCacheKey();
  const query = useQuery(queryKey, socialPostingApi.getYouTubeAccount, {
    staleTime: ReactQueryConstants.personalIntegrationSettingsStaleTime,
  });

  const queryStatusComponent = (
    <QueryStatus
      queryKey={queryKey}
      queryStatus={query.status}
      dataTestPrefix="youtube"
      failedToLoadText="Something went wrong while loading YouTube integration settings."
    />
  );

  return {
    query,
    queryStatusComponent,
  };
};
